import { config } from '../config';

const SUITE_MANAGER_TOKEN_KEY = 'suiteManagerToken';
const SUITE_MANAGER_REFRESH_KEY = 'suiteManagerRefresh';

export const hasSuiteManagerSession = () => !!sessionStorage.getItem(SUITE_MANAGER_TOKEN_KEY);

export const clearSuiteManagerSession = () => {
  sessionStorage.removeItem(SUITE_MANAGER_TOKEN_KEY);
  sessionStorage.removeItem(SUITE_MANAGER_REFRESH_KEY);
  sessionStorage.removeItem('userData');
  sessionStorage.removeItem('auth_token');
};

export const getDashboardLoginUrl = () => config.redirectUri;

export const getSuiteManagerBaseUrl = () => config.appLinks.suiteManager || config.frontstepsPaymentsUrl || '/';

export const buildSuiteManagerLogoutUrl = (returnTo: string = getDashboardLoginUrl()) => {
  const suiteManagerUrl = new URL(getSuiteManagerBaseUrl(), window.location.origin);
  suiteManagerUrl.search = '';
  suiteManagerUrl.hash = `#/logout?returnTo=${encodeURIComponent(returnTo)}`;

  return suiteManagerUrl.toString();
};

export const redirectToSuiteManagerLogout = (returnTo: string = getDashboardLoginUrl()) => {
  clearSuiteManagerSession();
  console.log('Logging out from Payments Dashboard');
  window.location.replace(buildSuiteManagerLogoutUrl(returnTo));
};
